/*
 * re-generate instructions:
 *
 * $ ./fi.sh console xhprof:debug:export-to-js
 * $ components/profiler/node_modules/.bin/prettier --write components/profiler/src/js/profiler/php-exports.generated.constants.ts
 */

export const FeatureFlags = {
    BETA: 'beta',
    API: 'api',
    BILLING: 'billing',
    BILLING_OLD: 'billing_old',
    AFTER_102020: 'after102020',
    QUICK_SUBMIT_INTERVAL: 'quick_submit_interval',
    CLI_SERVICES_DATA: 'cli_services_data',
    RESPONSE_TIME_TARGET: 'response_time_target',
    SHARE_TRACES: 'share_traces',
    AZURE_SSO: 'azure_sso',
    CHECK_HOST_RESTRICTIONS: 'check_host_restrictions',
    BOTTLENECKS: 'bottlenecks',
    IDE_INTEGRATION: 'ide_integration',
    OPEN_SOURCE: 'open_source',
    FREE_PREMIUM_ONBOARDING: 'free_premium_onboarding',
    BOTTLENECK_BETA: 'bottleneck_beta',
    CRAWLER_RATIO: 'crawler_ratio',
    ALLOW_FREEMAIL_SUBSCRIPTION: 'allow_freemail_subscription',
    AUTOMATIC_CALLGRAPH_TRACEPOINT: 'automatic_callgraph_tracepoint',
    TW8_TEAMS_OLD_SPAN_LIMIT: 'tw8_teams_old_span_limit',
    TIMELINE_WATERFALL: 'timeline_waterfall',
    MONITORING_ALL_SERVICES: 'monitoring_all_services',
    FORCE_DEFAULT_SERVICE: 'force_default_service',
    AI_AGENTS: 'ai_agents',
    ISSUE_TRACKER: 'issue_tracker',
} as const
